import {Component} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import {ClassifiedsMccService} from '../../../services/classifieds-mcc.service';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'classifieds-mcc-list',
    templateUrl: './classifieds-mcc-list.component.html',
    styleUrls: ['./classifieds-mcc-list.component.scss']
})
export class ClassifiedsMccListComponent {

    constructor(
        public urlService: UrlService,
        public classifiedsMccService: ClassifiedsMccService
    ) {}

    orderBy(orderBy: string, $event) {
        if (this.classifiedsMccService.data.allClassifiedsMcc.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    previewClassified(classified) {

    }

    editClassified(classified) {
        this.classifiedsMccService.classifiedInClassifiedModal = classified;
        this.classifiedsMccService.isClassifiedsModalShow = true;
    }

    changeClassifiedStatus(item, status) {

    }

    deleteClassified(classified) {
        this.classifiedsMccService.deleteClassified(classified);
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/classifieds-mcc/classifieds-mcc-list/classifieds-mcc-list.component.ts